import LogoHorizontal from "../../images/LogoHorizontal";
import Seal30 from "../../images/Seal30";

// I don't know why I can't have the same svg in 2 different places
// if the first one is child of a hidden element, all svgs of that kind are hidden
const CursedHeader = () => (
  <div className="quote:w-[670px] quote:m-auto print:w-[670px] print:m-auto py-4 border-b-4 border-gray-400 flex flex-col quote:flex-row print:flex-row gap-2">
    <div className="flex-1 flex flex-col quote:items-start print:items-start gap-2">
      <LogoHorizontal />

      <div className="quote:hidden print:hidden text-xs text-gray-500 text-center mb-4">
        Rua Prof. Zilda Andrade, 57, Bairro de Lourdes
        <br />
        Vitória, ES, 29042-751
        <br />
        alarmsystem.com.br – 27 3232-1000
        <br />
        comercial@alarmsystem.com.br
      </div>

      <div className="hidden quote:block print:block text-xs text-gray-500">
        Rua Prof. Zilda Andrade, 57, Bairro de Lourdes, Vitória, ES, 29042-751
        <br />
        alarmsystem.com.br / 27 3232-1000 / comercial@alarmsystem.com.br
      </div>
    </div>

    <div className="flex flex-col items-center">
      <Seal30 />
    </div>
  </div>
);

export default CursedHeader;
